import { NavLink } from 'react-router-dom'
import { Box } from '@mui/material'
import UseTranslation from '../../hooks/UseTranslation'

const SingleNavLinks = ({
  name, to, active, changeMenuStatusHandler, fullWidth, customStyles, icon,
}) => {
  const { t } = UseTranslation()
  return (
    <Box
      sx={[styles.singleLink, active &&
        styles.active, fullWidth && styles.fullWidth, customStyles]}>
      <NavLink to={to} onClick={changeMenuStatusHandler}>
        {icon}
        {t?.[name] || name}
      </NavLink>
    </Box>
  )
}
const styles = {
  singleLink: {
    cursor: 'pointer',
    display: 'flex',

    '& a': {
      margin: '0 15px',
      padding: '10px 20px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '7px',
      textDecoration: 'unset',
      fontFamily: 'Avenir',
      transition: 'all 0.5s',
      width: 'max-content',
    },

    '&:hover': {
      '& a': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
    },
  },
  fullWidth: {
    width: '100%',

    '& a': {
      width: '100%',
      borderRadius: '0',
      margin: '0 0 5px 0',
    },
  },
  active: {
    '& a': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
  },
}

export default SingleNavLinks
